import React from 'react';

import { WidgetMessage } from 'flow/types/Channel';
import { ChatSessionKey } from 'flow/types/EntityKeys';
import { TypedMap } from 'flow/types/TypedMap';
import { getStyledMessageBody } from 'flow/utils/message-utils';

interface Props {
    message: TypedMap<WidgetMessage>;
    sessionKey: ChatSessionKey;
}

const PbxMessageContent = ({ message, sessionKey }: Props) => (
    <div id="message-content" className="text-base/6 text-gray-800">
        {getStyledMessageBody(message, sessionKey)}
    </div>
);

export default PbxMessageContent;
